/**
 * Wordmark / Monogram - Adverdict "Decision Cut" brand marks
 *
 * Assets live in /public/brand (outlined SVGs from the corrected brand pack).
 * `tone="auto"` renders ink in light mode and white in dark mode via CSS so
 * no JS re-render is needed on theme change.
 */

import * as React from 'react';

import { cn } from '@/lib/utils';

export type WordmarkTone = 'auto' | 'ink' | 'white' | 'cobalt';

const WORDMARK_SRC: Record<Exclude<WordmarkTone, 'auto'>, string> = {
  ink: '/brand/wordmark-ink.svg',
  white: '/brand/wordmark-white.svg',
  cobalt: '/brand/wordmark-cobalt.svg',
};

export interface WordmarkProps {
  tone?: WordmarkTone;
  className?: string;
}

export function Wordmark({ tone = 'auto', className }: WordmarkProps): React.ReactElement {
  if (tone === 'auto') {
    return (
      <span className={cn('inline-flex', className)}>
        <img
          src={WORDMARK_SRC.ink}
          alt="Adverdict"
          className="block h-full w-auto dark:hidden"
        />
        <img
          src={WORDMARK_SRC.white}
          alt=""
          aria-hidden="true"
          className="hidden h-full w-auto dark:block"
        />
      </span>
    );
  }

  return (
    <img
      src={WORDMARK_SRC[tone]}
      alt="Adverdict"
      className={cn('block w-auto', className)}
    />
  );
}

export interface MonogramProps {
  tone?: 'ink' | 'white';
  className?: string;
}

export function Monogram({ tone = 'white', className }: MonogramProps): React.ReactElement {
  return (
    <img
      src={tone === 'white' ? '/brand/monogram-white.svg' : '/brand/monogram-ink.svg'}
      alt="Adverdict"
      className={cn('block w-auto', className)}
    />
  );
}
